import BaseComponent from '../../../../../base/base_component';
import ClockComponentController from '../../../../clock/clock_controller_component';
import DOM from '../../../../../utils/dom';
import _ from '../../../../../utils/underscore';
import {SYSTEM_EVENTS} from '../../../../../events/events';

let mobileView = require('./mobile_layout.html');

export default class SpainGameStripeMobile extends BaseComponent {
    static CLASS = 'SpainGameStripeMobile';

    init(params) {
        params = params || {};
        params.innerHtml = mobileView;
        super.init(params);

        this._appendClock();
        this._subscribe();
        this._setBalanceValue();
    }

    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.BALANCE_UPDATED, () => this._onBalanceUpdate());
    }

    _onBalanceUpdate() {
        this._setBalanceValue();
    }

    _setBalanceValue() {
        this._setValueFor('player_balance', this.serviceFactory.walletService().getBalance());
    }

    _appendClock() {
        let clockComponent = this.serviceFactory.componentFactoryService().createComponent(ClockComponentController, {
            datetime: this.serviceFactory.skinService().getTimeFormat()
        });
        this.appendChildComponent(clockComponent, '.cgp-stripe-clock');
        clockComponent.start();
    }

    setRegulationData(regulationData) {
        regulationData = regulationData || {};
        this._setValueFor('session_balance', regulationData.sessionBalance);
        this._setValueFor('session_bets', regulationData.sessionTotalBet);
        this._setValueFor('session_wins', regulationData.sessionTotalWin);
    }

    _setValueFor(sectionName, value) {
        if (_.isNullOrUndefined(value)) {
            value = 0;
        }

        DOM.text(this.querySelector('#' + sectionName).querySelector('#value'),
                 this.serviceFactory.currencyService().formatMoney(value));
    }

}

